import { combineReducers } from 'redux';
import { LoginReducer, UserPrefferenceReducer } from 'reducers';

const allReducers = combineReducers({
  loginReducer: LoginReducer,
  userPrefference: UserPrefferenceReducer
});

const appReducer = (state, action) => allReducers(state, action);
export default appReducer;
